var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeverityIconsBlackOutline24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4355 16.3798L13.5687 4.14841C12.8813 2.92398 11.1187 2.92398 10.4313 4.14841L3.56455 16.3798C2.8913 17.579 3.75798 19.0594 5.13324 19.0594H18.8668C20.242 19.0594 21.1087 17.579 20.4355 16.3798ZM14.7282 3.49748C13.5327 1.36803 10.4673 1.36803 9.27183 3.49748L2.40507 15.7288C1.23422 17.8144 2.74148 20.3891 5.13324 20.3891H18.8668C21.2585 20.3891 22.7658 17.8144 21.5949 15.7288L14.7282 3.49748Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1145 9.05677C11.1145 8.56803 11.5107 8.17182 11.9995 8.17182C12.4882 8.17182 12.8844 8.56803 12.8844 9.05677V12.8459C12.8844 13.3347 12.4882 13.7309 11.9995 13.7309C11.5107 13.7309 11.1145 13.3347 11.1145 12.8459V9.05677Z",
    fill: "#141414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8966 15.5877C12.8966 16.083 12.495 16.4845 11.9997 16.4845C11.5043 16.4845 11.1028 16.083 11.1028 15.5877C11.1028 15.0923 11.5043 14.6908 11.9997 14.6908C12.495 14.6908 12.8966 15.0923 12.8966 15.5877Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeverityIconsBlackOutline24);
export default __webpack_public_path__ + "static/media/severity-icons-black-outline-24.472f82f0fd8628f569d861300afcae7f.svg";
export { ForwardRef as ReactComponent };